export default __webpack_public_path__ + "static/media/van_1.e8ce902b.png";